import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedService, platformList } from 'src/app/shared.service';
import { CommonService } from 'src/app/providers/common.service';
// import { ApiService } from 'src/app/providers/api.service';
// import { NavService } from 'src/app/providers/nav.service';

@Component({
  selector: 'app-gamestylesection',
  templateUrl: './gamestylesection.component.html',
  styleUrls: ['./gamestylesection.component.css']
})
export class GamestylesectionComponent implements OnInit {

  @Input()
  filterType: any;

  @Input()
  initialFiltersData: any;

  @Input()
  gameStyleInitialId: any;

  @Input()
  tabName: string;

  @Output()
  getFiltersData = new EventEmitter<any>();

  @Output()
  sendFiltersData = new EventEmitter<any>();
  platformList = platformList;

  filters: any = {
    gameStyle: '',
    slate: '',
    playerId: '',
    changed : true
  };
  changed:boolean = false;
  slate = [];
  playersList = {};
  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));

  constructor(
    // private nav: NavService,
    // private api: ApiService,
    public commonService: CommonService,
    private sharedService: SharedService
  ) { }

  async ngOnInit() {

    let filters = this.sharedService.getFilter(this.tabName);
    if (filters) {
      setTimeout(async () => {
        if (this.initialFiltersData.gameStyleList.find(element => Number(filters.gameStyle) == Number(element.game_style_id) && element.slates && element.slates.length > 0)) {
          this.filters = {
            gameStyle: Number(filters.gameStyle),
            playerId: Number(filters.playerId),
            changed: false
          }

          this.filters = { ...this.filters }
          this.changeGameStyle(Number(filters.gameStyle), '')
          this.filters.slate = Number(filters.slate)
          this.sendFiltersData.emit(this.filters);
          this.sharedService.updatefiltersSelection(this.filters, this.tabName)

        } else {
          await this.setDefault();
        }
      }, 1000);
    } else {
      await this.setDefault();
    }

    this.sharedService.clearFilters.subscribe(() => this.setDefault())
  }

  async setDefault() {
    if (this.gameStyleInitialId) {
      this.filters.gameStyle = this.gameStyleInitialId;
      this.filters.changed =  false;

      await this.changeGameStyle(this.gameStyleInitialId, 'DefaultSelectedSlate');
      // this.sendFiltersData.emit(this.filters);
    } else if (this.filterType == 'Manager') {
      this.sendSelectedFiltersdata();
    }
  }

  async changeGameStyle(item, type, changed?:string) {
    this.filters.slate = '';
    // this.filters.playerId = '';
    // this.nav.changedSlateDrpDwn('');
    if (item == '') {
      this.slate = [];

    } else {
      if (this.initialFiltersData && this.initialFiltersData.gameStyleList) {
        let data =  this.initialFiltersData.gameStyleList.filter(element => item == element.game_style_id && element.slates && element.slates.length > 0);
        if(data.length > 0){
        if(this.commonService.platformandsport.platform_id == platformList.DraftKings){
          const blankSlates = data[0].slates.filter(({ slates_label }) => slates_label === ""  || slates_label === null);
          const withoutBlankSlates = data[0].slates.filter(({ slates_label }) => slates_label !== ""  && slates_label !== null);
          this.slate = [...blankSlates, ...withoutBlankSlates];
          this.filters.slate = this.slate[0].slates_id;

        }
        if(this.commonService.platformandsport.platform_id == platformList.FanDuel){
          const blankSlates = data[0].slates.filter(({ slates_label }) => slates_label === "Main"  || slates_label === null);
          const withoutBlankSlates = data[0].slates.filter(({ slates_label }) => slates_label !== "Main"  && slates_label !== null);
          this.slate = [...blankSlates, ...withoutBlankSlates];
          this.filters.slate = this.slate[0].slates_id;
        }

        this.sharedService.updatefiltersSelection(this.filters, this.tabName)
        // if (type == 'DefaultSelectedSlate') {
        //   this.filters.slate = this.slate[0].slates_id;
        // }
          }
      }
    }

    if (type != 'DefaultSelectedSlate') {
      this.sendSelectedFiltersdata();
    }
  }

  changeSlate(slateId) {
    // this.playersList = [];
    // this.initialFiltersData.gameStyleList.forEach(element => {
    //   if (this.filters.gameStyle == element.game_style_id && element.slates && element.slates.length > 0) {
    //     element.slates.forEach(innerelement => {
    //       if(innerelement.slates_id == slateId){
    //         this.playersList = innerelement.player;
    //       }
    //     });
    //   }
    // });
    // this.api.playerTeamList.()
    // this.nav.changedSlateDrpDwn(slateId);
    this.filters.changed = false;
    this.sendSelectedFiltersdata();
  }

  sendSelectedFiltersdata(changed?:string) {

      this.getFiltersData.emit(this.filters);
      this.sharedService.updatefiltersSelection(this.filters, this.tabName)


  }

  changedDATA(){
     this.changed  = true;
  }

}
